import SVGSelector from "./SVGSelector";

const SuperscriptScrollToBottom = ({ title, className }) => {
  return (
    <sup
      className={`cursor-pointer ${className}`}
      onClick={() =>
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth",
        })
      }
    >
      {title === "i" ? <SVGSelector name="i-svg" /> : null}
      {title === "ii" ? <SVGSelector name="ii-svg" /> : null}
      {title === "iii" ? <SVGSelector name="iii-svg" /> : null}
    </sup>
  );
};
export default SuperscriptScrollToBottom;
